import { useCallback, useState } from 'react';
import { useCreateRecord } from 'src/api/APIHooks';
import Notifier from 'common/helpers/Notifier';
import { uniq, without } from 'lodash';
import { usePendingNotificationCount } from 'src/components/Navigation/hooks/usePendingNotifications';

const useInvoiceExports = ({ currentEmployeeId }) => {
  const { incrementPendingNotificationCount } = usePendingNotificationCount();
  const [selectedInvoiceIds, setSelectedInvoiceIds] = useState([]);

  const deselectAll = useCallback(() => setSelectedInvoiceIds([]));
  const selectInvoices = useCallback((...invoiceIds) => {
    setSelectedInvoiceIds((prev) => uniq([...prev, ...invoiceIds]));
  }, []);
  const deselectInvoices = useCallback((...invoiceIds) => {
    setSelectedInvoiceIds((prev) => without(prev, ...invoiceIds));
  }, []);
  const { createRecord: createExport } = useCreateRecord('export');
  const downloadInvoices = useCallback(async (include_attachments = true) => {
    try {
      await createExport({
        export_type: 'invoices',
        requester: currentEmployeeId,
        state: 'requested',
        details: {
          include_attachments,
          invoice_ids: selectedInvoiceIds,
        },
      });
      incrementPendingNotificationCount('export');
      Notifier.dispatch('information', "Export file is processing. You'll receive a notification when it's ready.");
    } catch (error) {
      window.datadogLogs.logger.error('Failed to request export', { error });
      Notifier.dispatch('error', 'There was a problem requesting your export.');
    }
  }, [createExport, currentEmployeeId, selectedInvoiceIds]);
  return {
    deselectAll,
    deselectInvoices,
    downloadInvoices,
    selectInvoices,
    selectedInvoiceIds,
  };
};

export default useInvoiceExports;
